import {Button, Typography} from '@material-ui/core';
import AllstateBenefitsLogo from 'Core/assets/images/AllstateBenefitsLogo.png';
import AccessibilityStandardsModal from 'Core/components/Login/AccessibilityStandardsModal';
import {sequenceT} from 'fp-ts/lib/Apply';
import * as IO from 'fp-ts/lib/IO';
import React, {useEffect, useState} from 'react';
import Modal from 'Shared/components/Modal';
import {clearAccessTokenFromLocalStorage, login, loginIA} from 'Shared/utilities/Auth';
import {LocalStorageKey, toLocalStorage} from 'Shared/utilities/localStorage';
import './Login.sass';

const recordUserIsAllstateChannel = toLocalStorage(LocalStorageKey.IsEmployee);

const Login = () => {
  const [isLegalVisible, setLegalVisible] = useState(false);
  const [isAccessibilityVisible, setAccessibilityVisible] = useState(false);
  const onExternalUserLoginClick = sequenceT(IO.io)(recordUserIsAllstateChannel(false), loginIA);
  const onAllstateEmployeeLoginClick = sequenceT(IO.io)(recordUserIsAllstateChannel(true), login);

  useEffect(() => {
    sequenceT(IO.io)(clearAccessTokenFromLocalStorage)();
  }, []);

  return (
    <div className="login__background">
      <div className="login__welcome-text-container">
        <img src={AllstateBenefitsLogo} className="login__logo" alt="Allstate Benefits Logo" />
        <div className="login__welcome-form">
          <Typography variant="h6" className="login__welcome-text-header">
            Welcome to <strong>MyAccess</strong>
          </Typography>
          <p className="login__welcome-text-description">Benefits Management System</p>
          {/* <Button
            id="independent-agent-login-button"
            className="login__sign-in-button"
            variant="contained"
            onClick={onExternalUserLoginClick}
          >
            Independent Broker Login
          </Button> */}
          <Button
            id="allstate-employee-login-button"
            className="login__independent-agent-button"
            variant="contained"
            onClick={onAllstateEmployeeLoginClick}
          >
            THE STANDARD Channel Login
          </Button>
        </div>
        <footer className="login__footer">
          <button
            id="view-legal-disclaimer-button"
            className="login__legal-disclaimer-link"
            onClick={() => setLegalVisible(true)}
          >
            Legal Disclaimer
          </button>
          <Modal maxWidth="md" open={isLegalVisible} title="Legal Disclaimer" onClose={() => setLegalVisible(false)}>
            <div className="login__legal-disclaimer">
              By logging in and accessing this website, I represent and warrant that I have read, understand and agree
              to abide by The Standard's Electronic Service Agreement ("ESA"), which governs my use of The Standard's electronic services.
              My access and any information viewed and used will be for purposes as permitted under HIPAA and applicable
              state laws. I acknowledge and agree that The Standard may update the ESA from time to time by posting a revised
              version on this page and my continued use of this website shall constitute agreement to any such updates.
              This ESA supplements the other agreements I have with The Standard.
            </div>
          </Modal>
          <button
            id="web-accessibility-link-button"
            className="login__web-accessibility-link"
            onClick={() => setAccessibilityVisible(true)}
          >
            Accessibility Statement
          </button>
          <AccessibilityStandardsModal open={isAccessibilityVisible} onClose={() => setAccessibilityVisible(false)} />
        </footer>
      </div>
    </div>
  );
};

export default Login;
